import {
    AutocompleteOption,
    GroupAutocompleteOptions,
} from "components/Form/components/Autocomplete/Autocomplete";
import { Input } from "components/Form/components/Input/Input";
import { MoveToLocationAutocomplete } from "containers/Resources/components/CommonActions/MoveToLocation/MoveToLocationAutocomplete";
import { useEffect } from "react";
import { Field } from "react-final-form";

interface LocationFormFieldProps {
    locationId: string;
    changeValue: (value: string) => void;
    selectedLocation?: AutocompleteOption;
    options: { group: GroupAutocompleteOptions };
    label?: string;
    isRequired?: boolean;
}

export const LocationFormField = ({
    locationId,
    changeValue,
    selectedLocation,
    options,
    label = "location",
    isRequired = true,
}: LocationFormFieldProps) => {
    useEffect(() => {
        changeValue(locationId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locationId]);

    return (
        <Field name="location" id={"location"}>
            {({ input, fieldProps, fieldAttr, meta }) => {
                return (
                    <Input
                        fieldProps={{
                            ...fieldProps,
                            label,
                        }}
                        fieldAttr={{
                            ...fieldAttr,
                            required: isRequired,
                        }}
                        input={input}
                        meta={meta}
                    >
                        <MoveToLocationAutocomplete
                            changeValue={(value) => {
                                changeValue(value);
                                input?.onChange(value);
                            }}
                            value={input.value}
                            options={options}
                            name={input.name}
                            defaultValue={selectedLocation}
                        />
                    </Input>
                );
            }}
        </Field>
    );
};
